// extracted by mini-css-extract-plugin
export default {"modalHeader":"subLocaleModal_modalHeader__-NWzm","textLink":"subLocaleModal_textLink__euQhu"};